import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";

function QuestionReveal({ question, answer, index }) {
  const [revealed, setRevealed] = useState(false);

  return (
    <Card className="question-reveal-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>
          {index}. {question}
        </Card.Title>
        {revealed && <Card.Text>{answer}</Card.Text>}
        <Button variant="primary" onClick={() => setRevealed(!revealed)}>
          {revealed ? "Hide Answer" : "Reveal Answer"}
        </Button>
      </Card.Body>
    </Card>
  );
}

export default QuestionReveal;
